import React from "react";
import styles from "./styles.module.scss";
import classNames from "classnames";
import {createPortal} from "react-dom";
import CircularProgressIndicator from "@/app/components/circular_progress_indicator";
import IconButton from "@/app/components/icon_button";
import LazyAssets from "@/app/utils/assets_widget";

interface Props {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
  loading?: boolean;
  ignoreOverlay?: boolean;
  withPadding?: boolean;
  fullScreen?: boolean;
}

const Dialog: React.FC<Props> = ({
                                                   open,
                                                   onClose,
                                                   children,
                                                   loading = false,
                                                   ignoreOverlay = false,
                                                   withPadding = false,
                                                   fullScreen = false,
                                                 }) => {
  if (!open) return null;
  return createPortal(
    <div className={classNames(styles.bottomSheet, {
      [styles.open]: open,
      [styles.ignoreOverlay]: ignoreOverlay,
    })}>
      {!ignoreOverlay && (
        <div className={classNames(styles.overlay, {[styles.open]: open})} onClick={onClose}>
          {loading && <CircularProgressIndicator isGreen/>}
        </div>
      )}
      <div className={classNames(styles.sheet, {
        [styles.withPadding]: withPadding,
        [styles.fullScreen]: fullScreen,
      })}>
        <IconButton
          classNameForContainer={styles.closeButton}
          icon={<LazyAssets.Close />}
          onClick={onClose}
        />
        {!loading && children}
      </div>
    </div>,
    document.body
  );
};

export default Dialog;
